import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Fullbusbookingformarriagepne() {



  const cardData =
  {
    keyword: 'Full Bus Booking for Marriage Pune',
    heading: 'Amruta Travels: Full Bus Booking for Marriage Pune',
    headingDescription: 'Amruta Travels Pvt. Ltd. offers Full Bus Booking for Marriage in Pune, providing elegant and reliable transportation for wedding guests, family members, and special attendees. Our fleet includes luxury AC and Non-AC buses ranging from 17-seater minibuses to 53-seater coaches, ensuring comfortable and well-coordinated travel for every guest. Each bus features push-back seats, air conditioning, clean interiors, and ample luggage space, making long journeys relaxing and enjoyable. With professional, uniformed chauffeurs and on-time service, we ensure smooth transfers between venues, hotels, and destinations like Baner, Hadapsar, Kothrud, Pimpri Chinchwad, and Lonavala. Simplify your wedding logistics with Amruta Travels’ Full Bus Booking for Marriage in Pune — your trusted choice for punctual, safe, and luxurious wedding transportation.',

    top: 'Top Places to Visit in Pune with Amruta Travels',

"topPlaces": [
  {
    "title": "Sinhagad Fort",
    "description": "Perched on a rugged hill about 30 km from the city, Sinhagad Fort offers breathtaking views of the Sahyadri ranges. The fort is famed for the heroic battle led by Tanaji Malusare under Chhatrapati Shivaji Maharaj’s command. Visitors enjoy trekking, exploring ancient ruins, and savoring local snacks like pithla-bhakri. Sinhagad Fort embodies Pune’s valor, nature, and nostalgia in one frame."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most revered spiritual landmark, visited by millions of devotees annually. Its magnificently decorated Lord Ganesha idol radiates devotion and serenity. During Ganesh Chaturthi, the temple comes alive with lights, chants, and celebrations. It stands as Pune’s beacon of faith and divine grace in the heart of the city."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut shrine carved out of basalt in the 8th century. Dedicated to Lord Shiva, the temple’s circular Nandi pavilion and stone pillars display remarkable craftsmanship. Nestled in the city center, it provides a tranquil escape from urban life. Pataleshwar Temple connects modern Pune to its timeless spiritual legacy."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises gracefully over Pune, offering a blend of spirituality and scenic beauty. The temple complex atop the hill, dedicated to Lord Shiva and Goddess Parvati, was built by the Peshwas. Climbing its 108 steps rewards visitors with panoramic city views and a peaceful ambiance. Parvati Hill is Pune’s perfect fusion of devotion, history, and natural charm."
  },
    {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is an architectural masterpiece and a national monument of India’s freedom movement. Constructed in 1892, it served as a detention site for Mahatma Gandhi and his associates during the Quit India Movement. The palace’s sprawling gardens, museum, and Gandhi memorial exude peace and history. It is Pune’s enduring tribute to the nation’s struggle for independence."
  },
   {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada stands as the crown jewel of Pune’s Maratha heritage, built in 1732 by the Peshwas. Once the seat of the Maratha Empire, it boasts grand gates, intricately carved arches, and sprawling courtyards. The evening light and sound show vividly narrates tales of valor and tragedy. With its rich history and majestic aura, Shaniwar Wada remains the soul of Pune’s cultural identity."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure house of over 20,000 rare artifacts collected from across India. From musical instruments to traditional ornaments and sculptures, it offers a fascinating glimpse into India’s past. Each exhibit tells a story of art, culture, and human creativity. It’s a must-visit cultural gem for those exploring Pune’s heritage."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, Osho International Meditation Resort is a serene sanctuary that draws visitors from all over the world. Set amid lush gardens and modern architecture, it offers meditation, wellness programs, and personal growth workshops. The peaceful environment helps people reconnect with their inner selves. Osho Ashram is Pune’s global destination for spirituality and transformation."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a picturesque reservoir surrounded by rolling hills and greenery, just a short drive from Pune. It’s the main water source for the city and a favorite spot for picnics and evening drives. The scenic view of shimmering waters during sunset is mesmerizing. Khadakwasla offers Pune residents the perfect weekend retreat close to nature."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "The Pune Okayama Friendship Garden, inspired by Japan’s famous Korakuen Garden, blends Japanese landscaping with Indian flora. Its lush lawns, small bridges, flowing streams, and walking paths create a soothing environment for relaxation. Named after writer Pu La Deshpande, it’s ideal for families and photographers alike. The garden represents Pune’s bond of global friendship and aesthetic beauty."
  }
],



    "services": [
    {
      "name": "Full Bus Booking for Marriage Pune",
      "description": "Full Bus Booking for Marriage Pune offers comprehensive rental services for entire buses dedicated to wedding events. This service is ideal for transporting large groups of wedding guests efficiently and comfortably. The buses are well-maintained and come with professional drivers who ensure timely pickups and smooth rides throughout the wedding festivities."
    },
    {
      "name": "Marriage Bus Hire Pune",
      "description": "Marriage Bus Hire Pune specializes in providing buses for all marriage-related transportation needs, including guest transfers, bridal party commutes, and family shuttles. With a variety of bus sizes and comfort levels, clients can choose from budget-friendly to premium options, all ensuring reliability and elegance."
    },
    {
      "name": "Wedding Full Bus Pune",
      "description": "Wedding Full Bus Pune delivers fully booked buses tailored for weddings, ensuring that your entire group travels together without hassle. The buses feature clean, comfortable seating, ample luggage space, and courteous drivers who understand the importance of punctuality during wedding celebrations."
    },
    {
      "name": "AC Marriage Bus Pune",
      "description": "AC Marriage Bus Pune provides air-conditioned buses perfect for wedding events in Pune’s warm climate. These buses ensure a cool and pleasant journey for guests, combining comfort with timely service. They are equipped with modern AC systems, plush interiors, and driven by professional chauffeurs focused on guest safety and satisfaction."
    },
    {
      "name": "Non AC Marriage Bus Pune",
      "description": "Non AC Marriage Bus Pune offers economical yet reliable transportation for weddings without air conditioning. These buses maintain high standards of cleanliness and safety, making them suitable for budget-conscious clients who seek dependable service for short-distance wedding transfers and guest travel."
    },
    {
      "name": "Luxury Marriage Bus Pune",
      "description": "Luxury Marriage Bus Pune presents premium buses with upscale interiors, elegant seating, and additional amenities designed to enhance the wedding experience. Ideal for VIP guests and bridal parties, these buses combine sophistication with comfort and professional, discreet driver service."
    },
    {
      "name": "35 Seater Marriage Bus Pune",
      "description": "35 Seater Marriage Bus Pune offers mid-sized buses ideal for medium-sized wedding groups. These buses balance capacity with comfort, featuring spacious seating, ample luggage storage, and efficient service to meet the demands of wedding schedules."
    },
    {
      "name": "45 Seater Marriage Bus Pune",
      "description": "45 Seater Marriage Bus Pune provides larger buses suitable for bigger wedding parties and guest groups. Equipped with comfortable seating and safety features, these buses ensure smooth and timely transportation for all wedding-related travel."
    },
    {
      "name": "53 Seater Marriage Bus Pune",
      "description": "53 Seater Marriage Bus Pune caters to very large wedding gatherings, offering spacious buses that accommodate extended families and guests. These buses feature advanced safety systems, comfortable interiors, and experienced drivers committed to flawless wedding logistics."
    },
    {
      "name": "Marriage Bus Hire in Baner",
      "description": "Marriage Bus Hire in Baner specializes in providing wedding transportation solutions for clients in the Baner area. This localized service ensures timely pickups, clean and well-maintained buses, and drivers familiar with the area to navigate efficiently during wedding events."
    },
    {
      "name": "Marriage Bus Hire in Hinjewadi",
      "description": "Marriage Bus Hire in Hinjewadi caters to wedding parties and guests in the Hinjewadi locality, offering a fleet of well-equipped buses suitable for different group sizes. The service prides itself on punctuality, vehicle cleanliness, and professional drivers experienced in managing wedding day logistics."
    },
    {
      "name": "Marriage Bus Hire in Hadapsar",
      "description": "Marriage Bus Hire in Hadapsar provides dependable wedding transportation for clients in Hadapsar and surrounding areas. Offering a range of buses from mid-size to luxury options, this service focuses on guest comfort, timely service, and personalized attention to detail during weddings."
    },
    {
      "name": "Affordable Marriage Bus Pune",
      "description": "Affordable Marriage Bus Pune delivers cost-effective wedding bus rental options that do not compromise on quality or safety. This service is ideal for clients on a budget who want reliable and well-maintained vehicles with professional drivers to ensure smooth wedding transportation."
    },
    {
      "name": "Marriage Guest Bus Pune",
      "description": "Marriage Guest Bus Pune specializes in transporting wedding guests comfortably and efficiently. These buses are designed to handle group travel with ease, featuring spacious seating and attentive drivers to make guests feel welcome and cared for during their journey."
    },
    {
      "name": "Marriage Transport Pune",
      "description": "Marriage Transport Pune offers comprehensive transportation solutions covering all aspects of wedding logistics, including guest transfers, bridal party movements, and vendor transport. The service is known for its professionalism, flexibility, and attention to wedding day timelines."
    },
    {
      "name": "Online Marriage Bus Booking Pune",
      "description": "Online Marriage Bus Booking Pune provides a convenient digital platform for booking wedding buses quickly and securely. Customers can choose from various bus types, check availability in real-time, and enjoy seamless payment options with 24/7 customer support."
    },
    {
      "name": "Marriage Volvo Bus Pune",
      "description": "Marriage Volvo Bus Pune offers luxury Volvo buses for weddings, combining superior comfort, advanced safety features, and stylish interiors. Perfect for transporting VIP guests or long-distance wedding travel, these buses ensure a premium experience."
    },
    {
      "name": "Wedding Full Coach Hire Pune",
      "description": "Wedding Full Coach Hire Pune specializes in providing large coaches for full-group wedding transportation. These coaches feature spacious interiors, luxury amenities, and experienced drivers to manage wedding day routes smoothly, ensuring your entire party travels together in comfort and style."
    }
  ],
  "tableData": [
    ["Full Bus Booking for Marriage Pune", "Marriage Bus Hire Pune"],
    ["Wedding Full Bus Pune", "AC Marriage Bus Pune"],
    ["Non AC Marriage Bus Pune", "Luxury Marriage Bus Pune"],
    ["35 Seater Marriage Bus Pune", "45 Seater Marriage Bus Pune"],
    ["53 Seater Marriage Bus Pune", "Marriage Bus Hire in Baner"],
    ["Marriage Bus Hire in Hinjewadi", "Marriage Bus Hire in Hadapsar"],
    ["Affordable Marriage Bus Pune", "Marriage Guest Bus Pune"],
    ["Marriage Transport Pune", "Online Marriage Bus Booking Pune"],
    ["Marriage Volvo Bus Pune", "Wedding Full Coach Hire Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Full Bus Booking for Marriage in Pune",
    "WhyChoosedescription": "Amruta Travels Pvt Ltd offers full bus booking services for weddings in Pune, providing comfortable and reliable transportation for your guests."
  },
  {
    "WhyChooseheading": "Wide Range of Bus Options",
    "WhyChoosedescription": "Choose from various bus sizes to accommodate small to large wedding parties with ease and style."
  },
  {
    "WhyChooseheading": "Clean and Well-Maintained Vehicles",
    "WhyChoosedescription": "Our buses are regularly serviced and sanitized to ensure a safe and hygienic travel experience for all passengers."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "Enjoy upfront pricing with no hidden fees, making your wedding transportation hassle-free and budget-friendly."
  },
  {
    "WhyChooseheading": "Flexible Rental Durations",
    "WhyChoosedescription": "Book buses for a few hours or multiple days, tailored to your wedding schedule and guest requirements."
  },
  {
    "WhyChooseheading": "Professional and Courteous Drivers",
    "WhyChoosedescription": "Our experienced drivers ensure punctual pickups and smooth rides, allowing you to focus on your special day."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round-the-clock to assist with bookings, route planning, and last-minute changes."
  },
  {
    "WhyChooseheading": "Easy and Quick Booking Process",
    "WhyChoosedescription": "Book your full wedding bus easily online or via phone, with prompt confirmation and reliable service in Pune."
  }
]



















  }

const faqData = [
  {
    question: 'Does Amruta Travels Pvt Ltd offer full bus booking services for marriages in Pune?',
    answer: 'Yes, Amruta Travels Pvt Ltd provides full bus booking services for marriages in Pune, ensuring comfortable and timely transportation for wedding guests.',
  },
  {
    question: 'How can I book a full bus for a marriage in Pune with Amruta Travels?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24×7 customer support team in Pune.',
  },
  {
    question: 'What types of buses are available for full bus booking for marriages in Pune?',
    answer: 'We offer a range of buses including mini buses, 17 seater Urbania, 35 seater, 45 seater, 50 seater, and 53 seater buses suitable for wedding groups of all sizes.',
  },
  {
    question: 'Are the drivers experienced and professional for marriage bus bookings in Pune?',
    answer: 'Yes, all our drivers are courteous, professional, and experienced in managing wedding transportation efficiently and safely.',
  },
  {
    question: 'Can buses be booked for all wedding-related transportation needs in Pune?',
    answer: 'Absolutely. Our buses are perfect for guest transportation, ceremonies, receptions, and all other wedding-related travel requirements.',
  },
  {
    question: 'Is full bus booking for marriages available 24×7 in Pune?',
    answer: 'Yes, Amruta Travels offers 24×7 full bus booking services for marriages in Pune to accommodate your schedule.',
  },
  {
    question: 'What safety and hygiene protocols are followed for marriage bus bookings?',
    answer: 'All vehicles are sanitized thoroughly before each trip, and drivers adhere to strict hygiene and safety measures to ensure a safe ride.',
  },
  {
    question: 'What payment options are available for full bus booking for marriages in Pune?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for your convenience.',
  },
  {
    question: 'Is customer support available throughout the full bus booking period for marriages in Pune?',
    answer: 'Yes, our 24×7 customer support team is available to assist you anytime during your wedding bus rental.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sanjay Kulkarni',
    feedback: 'Booking a full bus for our wedding through Amruta Travels Pune was seamless. The bus was clean and the driver punctual.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Meera Joshi',
    feedback: 'Excellent service for wedding bus booking. Amruta Travels made the entire process hassle-free and comfortable.',
    rating: 5,
  },
];





































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "24 Seater Bus for Rent in Pune", link: "24-seater-bus-for-rent-in-pune" },
  { place: "/images/keyword/2.jpg", text: "16 Seater Urbania for Rent in Pune", link: "16-seater-urbania-for-rent-in-pune" },
  { place: "/images/keyword/3.jpg", text: "14 Seater Urbania Hire in Pune", link: "14-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/4.jpg", text: "17 Seater Urbania Hire in Pune", link: "17-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/5.jpg", text: "Mini Bus On Rent in Pimpri Chinchwad", link: "mini-bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/6.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
  { place: "/images/keyword/7.jpg", text: "Force Urbania 17 Seater On Rent in Pune", link: "force-urbania-17-seater-on-rent-in-pune" },
  { place: "/images/keyword/8.jpg", text: "35 Seater Bus On Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/9.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/10.jpg", text: "53 Seater Bus On Rent in Pune", link: "53-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/11.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/12.jpg", text: "Bus On Rent in Pune", link: "bus-on-rent-in-pune" },
  { place: "/images/keyword/13.jpg", text: "Bus Hire in Pune", link: "bus-hire-in-pune" },
  { place: "/images/keyword/14.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/15.jpg", text: "Bus Rental for Corporate Events in Pune", link: "bus-rental-for-corporate-events-in-pune" },
  { place: "/images/keyword/16.jpg", text: "Wedding Bus Booking Online Pune", link: "wedding-bus-booking-online-pune" },
  { place: "/images/keyword/17.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
  { place: "/images/keyword/18.jpg", text: "Bus Hire for Party Events in Pune", link: "bus-hire-for-party-events-in-pune" },
  { place: "/images/keyword/19.jpg", text: "Full Bus Booking for Marriage Pune", link: "full-bus-booking-for-marriage-pune" },
  { place: "/images/keyword/20.jpg", text: "AC Luxury Bus On Rent in Pune", link: "ac-luxury-bus-on-rent-in-pune" },
  { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
  { place: "/images/keyword/22.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "luxury-force-urbania-on-rent-in-pune" },
  { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Pune for Corporate", link: "urbania-on-rent-in-pune-for-corporate" },
  { place: "/images/keyword/24.jpg", text: "Pune to Goa Urbania On Rent", link: "pune-to-goa-urbania-on-rent" },
  { place: "/images/keyword/25.jpg", text: "Pune to Mumbai Urbania on Rent", link: "pune-to-mumbai-urbania-on-rent" }
];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Full Bus Booking for Marriage Pune",
  "image": "https://www.amrutatravelspvtltd.com/images/keyword/19.jpg",
  "description": "Book Full Bus for Marriage in Pune with Amruta Travels Pvt. Ltd. Choose from AC, Non-AC, and Luxury wedding buses for guest transport and functions. Affordable, comfortable, and reliable full bus booking service for weddings in Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels Pvt. Ltd."
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.88",
    "ratingCount": "16120"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4600",
    "availability": "https://schema.org/InStock",
    "url": "https://www.amrutatravelspvtltd.com/full-bus-booking-for-marriage-pune"
  }
};




  return (
    <div>

<Helmet>
  <title>Full Bus Booking for Marriage Pune | AC & Luxury Wedding Bus Hire | Amruta Travels Pvt. Ltd.</title>
  <meta
    name="description"
    content="Book Full Bus for Marriage in Pune with Amruta Travels Pvt. Ltd. Offering AC, Non-AC, and Luxury wedding buses for guest transport and ceremonies. Affordable and reliable marriage bus rental in Pune."
  />
  <meta
    name="keywords"
    content="Full Bus Booking for Marriage Pune, Marriage Bus Hire Pune, Wedding Full Bus Pune, AC Marriage Bus Pune, Non AC Marriage Bus Pune, Luxury Marriage Bus Pune, 35 Seater Marriage Bus Pune, 45 Seater Marriage Bus Pune, 53 Seater Marriage Bus Pune, Marriage Bus Hire in Baner, Marriage Bus Hire in Hinjewadi, Marriage Bus Hire in Hadapsar, Affordable Marriage Bus Pune, Marriage Guest Bus Pune, Marriage Transport Pune, Online Marriage Bus Booking Pune, Marriage Volvo Bus Pune, Wedding Full Coach Hire Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/images/page-header-bg-1-1.jpg)",
          }}
        ></div>
        <div className="container">
          <div className="page-header__content">
            <h2 className="page-header__title">   {cardData.keyword}</h2>
          </div>
        </div>
      </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/19.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Amruta Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Amruta Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918010014995" className="pc-call">+91 8010014995</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918010014995"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918010014995" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@amrutatravelspvtltd.com" className="pc-email">
                      booking@amrutatravelspvtltd.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Amruta Travels Pvt Ltd</strong><br />
                      Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Fullbusbookingformarriagepne;